/*eslint-disable*/
import * as actions from 'state/modules/manage';
import * as utils from 'lib/utility';
import { FixedTabs, Popup, VirtualizedSelect } from 'containers';
import { connect } from 'react-redux';
import React, { Component, PropTypes } from 'react';
import Dialog from 'react-toolbox/lib/dialog';
import isEqual from 'lodash/isEqual';
import Modal from 'react-modal';
import translate from 'i18n/translate';
import _ from 'lodash';
import 'react-select/dist/react-select.css';
import styles from './Manage.css';
import ProgressBar from 'react-toolbox/lib/progress_bar';

const debug = _debug('app:Manage');
let  stateSearchedListDataForZip = [];
let  zipSearchedListDataForCity = [];
class Manage extends Component {
  static defaultProps = {
    options: []
  }
  static propTypes = {
    popupVisible: PropTypes.string,
    currentLanguage: PropTypes.string,
    strings: React.PropTypes.shape({}),
    showPopup: PropTypes.func,
    hidePopup: PropTypes.func,
    fetchData: PropTypes.func,
    tabOneList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabTwoList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabActiveLeadsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabOneSearchedLeads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabOneSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabTwoSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabActiveSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    leadsData: PropTypes.arrayOf(PropTypes.shape({})),
    activeIndex: PropTypes.number,
    updateActiveIndex: PropTypes.func,
    updateFilterExpanded: PropTypes.func,
    filterExpanded: PropTypes.bool,
    filterValues: PropTypes.shape({}),
    updateFilter: PropTypes.func,
    applyFilter: PropTypes.func,
    applyPersistFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    applySearchName: PropTypes.func,
    priAndSecRecordMapping: PropTypes.shape({}),
    fetchFilterState: PropTypes.func,
    searchValueNamePriorityTab: PropTypes.string,
    searchValueNameTabOne: PropTypes.string,
    searchStreetAddressPriorityTab: PropTypes.string,
    searchStreetAddressTabOne: PropTypes.string,
    searchValueNameTabTwo: PropTypes.string,
    searchStreetAddressTabTwo: PropTypes.string,
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    updatePhoneParameter: PropTypes.func,
    searchPhonePriorityTab: PropTypes.string,
    searchPhone: PropTypes.string,
    applySearchPhone: PropTypes.func,
    searchPhoneTabTwo: PropTypes.string,
    licensedStates: React.PropTypes.shape([]),
    getOpenLeads: PropTypes.func,
    updateSelectedSearchValues: PropTypes.func,
    fetchOpenLeadSearchData: PropTypes.func,
    updateFilterPersistState: PropTypes.func,
    isLoading: PropTypes.bool,
    isLoadingData: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      openSearch: false,
      licensedStatesValue: [],
      stateValue: '',
      citySelectValue: [],
      zipSelectValue: [],
      isStateSelected: false,
      active: false,
      isLoading: true
    };
  }

  componentWillMount() {
    this.props.fetchOpenLeadDataArray(); 
  }

  componentDidMount() {
    // startPersistingData();
    this.props.fetchData()
    .then(() => this.props.fetchOpenLeadDataArray())
    .then(() => {
      this.props.fetchFilterState()
    .then(() => this.props.applyPersistFilter())
    .then(() => 
    { 
      this.setState({ isLoading : false })
    })
    .catch((error) => {
          debug('Promise errors', error);
        });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.filterValues, this.props.filterValues)) {
      this.props.updateFilterPersistState(nextProps.filterValues);
    }
  }

  action = strings => [
    { label: strings.ok, onClick: this.handleToggle }
  ];

  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }

  getColumndata = () => {
    const { strings } = this.props;
    const tempColumnData = [
      {
        label: strings.name,
        assignedLabel: 'Name',
        dataKey: 'quickbarName',
        flexGrow: 1.7,
        styleName: ''
      },
      {
        label: strings.leadtype,
        assignedLabel: 'Lead Type',
        dataKey: 'leadType',
        flexGrow: 1.5,
        styleName: ''
      },
      {
        label: strings.phone,
        assignedLabel: 'Phone',
        dataKey: 'phone',
        flexGrow: 1.6,
        styleName: 'phone'
      },
      {
        label: '',
        assignedLabel: 'Call Type',
        dataKey: 'callType',
        flexGrow: 0.5,
        styleName: 'boldStyling'
      },
      {
        label: strings.address,
        assignedLabel: 'Address',
        dataKey: 'residentialAddress',
        flexGrow: 1.8,
        styleName: ''
      },
      {
        label: strings.city,
        assignedLabel: 'City',
        dataKey: 'city',
        flexGrow: 1.2,
        styleName: ''
      },
      {
        label: strings.zip,
        assignedLabel: 'Zip',
        dataKey: 'zip',
        flexGrow: 1.5,
        styleName: ''
      },
      {
        label: strings.disposition,
        assignedLabel: 'Disposition',
        dataKey: 'disposition',
        flexGrow: 1.8,
        styleName: ''
      },
      {
        label: strings.tier,
        assignedLabel: 'Tier',
        dataKey: 'tier',
        flexGrow: 1.1,
        styleName: ''
      },
      {
        label: strings.expires,
        assignedLabel: 'Expires',
        dataKey: 'expires',
        flexGrow: 1.9,
        styleName: ''
      },
      {
        label: '',
        assignedLabel: '',
        dataKey: 'icon',
        styleName: '',
        flexGrow: 0.4
      }
    ];

    return tempColumnData;
  }

  getFilterData = () => {
    const { strings } = this.props;
    const tempFilterData = [
      {
        label: strings.state,
        options: 'state',
        tab: 'both',
        type: 'state',
        hintText: strings.state.toLowerCase()
      },
      {
        label: strings.county,
        options: 'county',
        tab: 'both',
        type: 'county',
        hintText: strings.county.toLowerCase()
      },
      {
        label: strings.city,
        options: 'city',
        tab: 'both',
        type: 'city',
        hintText: strings.city.toLowerCase(),
      },
      {
        label: strings.zip,
        options: 'zip',
        tab: 'both',
        type: 'zip',
        hintText: strings.zip.toLowerCase(),
      },
      {
        label: strings.leadtype,
        options: 'leadType',
        tab: 'both',
        type: 'leadType',
        hintText: strings.leadtype.toLowerCase()
      },
      {
        label: strings.campaign,
        options: 'campaign',
        tab: 'both',
        type: 'campaign',
        hintText: ''
      },
      {
        label: strings.campaignType,
        options: 'campaignPurpose',
        tab: 'both',
        type: 'campaignPurpose',
        hintText: ''
      },
      {
        label: strings.language,
        options: 'language',
        tab: 'both',
        type: 'language',
        hintText: strings.language.toLowerCase()
      },
      {
        label: strings.disposition,
        options: 'disposition',
        tab: 'both',
        type: 'disposition',
        hintText: strings.disposition.toLowerCase()
      },
      {
        label: strings.tier,
        options: 'tier',
        tab: 'both',
        type: 'tier',
        hintText: 'Search Tier'
      }
    ];
    return tempFilterData;
  }

  getSearchFilterData = () => {
    const { strings } = this.props;
    const tempFilterData = [
      {
        label: strings.state,
        options: 'state',
        tab: 'both',
        type: 'state',
        hintText: strings.state.toLowerCase()
      },
      {
        label: strings.city,
        options: 'city',
        tab: 'both',
        type: 'city',
        hintText: strings.city.toLowerCase(),
      },
      {
        label: strings.zip,
        options: 'zip',
        tab: 'both',
        type: 'zip',
        hintText: strings.zip.toLowerCase(),
      }
    ];
    return tempFilterData;
  }

  getStates = (states) => {
    // const stateData = util.stateDropDownData(states);
    const statesData = _.sortBy(_.uniq(states)); //eslint-disable-line
    console.log('statesData', statesData);
    const finalStatesData = statesData.map(item => (
      {
        value: this.toTitleCase(item),
        label: item,
        clearableValue: false,
      }));
      console.log('finalStatesData', finalStatesData);
      return finalStatesData;
  }

  getZip = (leadsData) => {
    // filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary)),
    const fullZip = leadsData.map(obj => obj.zip);
    let zip = fullZip.map(obj => obj.substr(0, 5));
    zip = _.sortBy(_.uniq(zip));
    return zip.map(item => (
      {
        value: item,
        label: item ? item.replace(/\-/g, '') : '' //eslint-disable-line
      }));
  }

  applyFilter = (record) => {

  }

  getCitiesAndZip = (state, record) => {
    const leadsData = this.props.leadsData;
    const stateCode = state.length > 0 ? utils.getStateCode(state[0]) : '';
    const filteredLeadsData = leadsData.filter(obj => (obj.state === stateCode));
    if (record.type === 'City') {
      if (zipSearchedListDataForCity.length > 0) {
        const cities = zipSearchedListDataForCity.map(obj => obj);
        const citiesData = _.sortBy(_.uniq(cities)); //eslint-disable-line
        const citiesValueFiltered = [];
        citiesData.map((oneitem) => {
          filteredLeadsData.map((twoitem) => {
            if (twoitem.zip.substr(0, 5) === oneitem) {
              citiesValueFiltered.push(twoitem);
            }
          });
        });
        let filterOnlyCities = citiesValueFiltered.map(obj => obj.city);
        filterOnlyCities = _.sortBy(_.uniq(filterOnlyCities));
        let filteredLeadscities = filteredLeadsData.map(obj => obj.city);
        filteredLeadscities = _.sortBy(_.uniq(filteredLeadscities));
        let shouldDisableField = false;
        let filteredIndex = 0;
        return filteredLeadscities.map((item) => {
          if (item !== filterOnlyCities[filteredIndex]) {
            shouldDisableField = true;
          } else {
            shouldDisableField = false;
            filteredIndex += 1;
          }
          return {
              disable: shouldDisableField,
              value: item,
              label: item,
              clearableValue: false
          };
        });
      } else {
        const cities = filteredLeadsData.map(obj => obj.city);
        const citiesData = _.sortBy(_.uniq(cities)); //eslint-disable-line
        const finalCityValues = citiesData.map(item => (
          {
            value: item,
            label: item,
            clearableValue: false,
          }));
          console.log('finalCityValues', finalCityValues);
          return finalCityValues;
      }
    }
    if (stateSearchedListDataForZip.length > 0) {
      let fullZip = stateSearchedListDataForZip.map(obj => obj.zip);
      let zip = fullZip.map(obj => obj.substr(0, 5));
      zip = _.sortBy(_.uniq(zip));
      let shouldDisableField = false;
      let filteredIndex = 0;
      let newListZipLeads = filteredLeadsData.map(obj => obj.zip);
      let newListZipLeadszip = newListZipLeads.map(obj => obj.substr(0, 5));
      newListZipLeadszip = _.sortBy(_.uniq(newListZipLeadszip));
      return newListZipLeadszip.map((item) => {
        if (item !== zip[filteredIndex]) {
          shouldDisableField = true;
        } else {
          shouldDisableField = false;
          filteredIndex += 1;
        }
        return {
            disable: shouldDisableField,
            value: item,
            label: item ? item.replace(/\-/g, '') : '', //eslint-disable-line
            clearableValue: false
        };
      });
    } else {
      let fullZipElse = filteredLeadsData.map(obj => obj.zip);
      let zipElse = fullZipElse.map(obj => obj.substr(0, 5));
      zipElse = _.sortBy(_.uniq(zipElse));
      return zipElse.map(item => (
        {
          value: item,
          label: item ? item.replace(/\-/g, '') : '', //eslint-disable-line
          clearableValue: false
        }));  
    }
  }

  licensedStates = (key, value) => {
    let valueSelected;
    console.log('key', key);
    const request = new Promise((resolve) => {
      valueSelected = value && value.length ? value.map(item => item.label) : [];
      console.log('valueSelected', valueSelected);
      stateSearchedListDataForZip = [];
      zipSearchedListDataForCity = [];
      this.setState({ valueSelected });
      this.setState({
        licensedStatesValue: valueSelected,
        citySelectValue: [],
        zipSelectValue: []
      });
      resolve(valueSelected);
    });
    console.log('valueSelected', valueSelected);
    return request;
  };

  citySelect = (key,value) => {
    let valueSelected;
    const leadsData = this.props.leadsData;
    const stateValue = this.state.licensedStatesValue;
    const stateCode = stateValue.length > 0 ? utils.getStateCode(stateValue[0]) : '';
    const filteredLeadsData = leadsData.filter(obj => (obj.state === stateCode));
    const request = new Promise((resolve) => {
      valueSelected = value && value.length ? value.map(item => item.label) : [];
      this.setState({ valueSelected });
      this.setState({
        citySelectValue: valueSelected
      });
      resolve(valueSelected);
    });
    if (valueSelected.length === 0) {
      this.setState({
        zipSelectValue: []
      });
    }
    if (valueSelected.length > 0) {
      valueSelected.map((cityValue) => {
        filteredLeadsData.map((objzip) => {
          if (objzip.city === cityValue) {
            stateSearchedListDataForZip.push(objzip);
            return stateSearchedListDataForZip;
          }
        });
      });
    } else {
      stateSearchedListDataForZip = [];
    }
    return request;
  };

  zipSelect = (data,value) => {
    let valueSelected;
    const leadsData = this.props.leadsData;
    const stateValue = this.state.licensedStatesValue;
    const stateCode = stateValue.length > 0 ? utils.getStateCode(stateValue[0]) : '';
    const filteredLeadsData = leadsData.filter(obj => (obj.state === stateCode));
    let newListZipLeads = filteredLeadsData.map(obj => obj.zip);
    let newListZipLeadszip = newListZipLeads.map(obj => obj.substr(0, 5));
    const request = new Promise((resolve) => {
      valueSelected = value && value.length ? value.map(item => item.label) : [];
      this.setState({ valueSelected });
      this.setState({
        zipSelectValue: valueSelected,
      });
      resolve(valueSelected);
    });
    if (valueSelected.length > 0) {
      valueSelected.map((zipValue) => {
        newListZipLeadszip.map((objcity) => {
          if (objcity === zipValue) {
            zipSearchedListDataForCity.push(objcity);
            return zipSearchedListDataForCity;
          }
        });
      });
    } else {
      zipSearchedListDataForCity = [];
    }
    return request;
  };

  toTitleCase = (str) => {
    if (str && typeof str === 'string' && str.length > 2) {
      return str.replace(/\w\S*/g, txt =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }
    return str;
  };

  searchButton = () => {
    const stateSelectedValue = this.state.licensedStatesValue;
    const { strings } = this.props;
    if (stateSelectedValue.length > 0) {
      this.props.getOpenLeads(this.state.licensedStatesValue,
        this.state.citySelectValue, this.state.zipSelectValue);
      this.props.updateSelectedSearchValues(this.state.licensedStatesValue,
        this.state.citySelectValue, this.state.zipSelectValue);
      this.props.clearFilter();
      // this.props.applyFilter();
      // this.props.updateSelectedRecords('removeAll');
      this.props.updateNameSearchParameter('', this.props.activeIndex);
      this.props.updateStreetSearchParameter('', this.props.activeIndex);
      this.props.updatePhoneParameter('', this.props.activeIndex);
      // this.props.resetActiveFilter();
      this.setState({
        openSearch: false,
        active: false,
        isStateSelected: false,
        licensedStatesValue: [],
        citySelectValue: [],
        zipSelectValue: []
      });
    } else {
      this.setState({ active: true, openSearch: true, errorMessage: strings.searchCriteriaMsg });
    }
  }

  searchPopupAction() {
    this.setState({
      openSearch: true,
      licensedStatesValue: [],
      citySelectValue: [],
      zipSelectValue: []
    });
  }

  searchFilterDropdowns = () => {
    const { strings } = this.props;
    const searchPopFilterData = utils.searchPopUpFilterMap(null, strings);
    const views = searchPopFilterData.map((record) => {
      if (record.type === 'State') {
            return (
              <div className={styles.filterItem} key={record.label}>
                <label htmlFor={record.label}> {record.label} </label>
                <VirtualizedSelect
                  options={this.getStates(this.props.licensedStates)}
                  type={record.type}
                  updateFilter={this.licensedStates}
                  tetherToWindow={false}
                  hintText={record.hintText}
                  filterValues={this.state.licensedStatesValue}
                  currentLanguage={this.props.currentLanguage}
                  maxHeight={250}
                  searchable
                  searchBoxOpen='searchBoxOpen'
                  placeholder={this.state.licensedStatesValue.length > 0 ? this.state.licensedStatesValue : strings.selectionRequiredHint}
                  SelectPlaceholderPopupColor={'White'}
                  singleSelect
                />
              </div>
            );
      }
      else if (record.type === 'City') {
        return (
          <div className={styles.filterItem} key={record.label}>
            <label htmlFor={record.label}> {record.label} </label>
            <VirtualizedSelect
              options={this.getCitiesAndZip(this.state.licensedStatesValue, record)}
              type={record.type}
              searchable
              updateFilter={this.citySelect}
              hintText={record.hintText}
              filterValues={this.state.citySelectValue}
              currentLanguage={this.props.currentLanguage}
              tetherToWindow={false}
              maxHeight={250}
              searchBoxOpen='searchBoxOpen'
              citySearch={'citySearch'}
              SelectPlaceholderPopupColor={'White'}
              disabled={this.state.licensedStatesValue.length > 0 ? false : true}
            />
          </div>
        );
      }
      return (
        <div className={styles.filterItem} key={record.label}>
          <label htmlFor={record.label}> {record.label} </label>
          <VirtualizedSelect
            options={this.getCitiesAndZip(this.state.licensedStatesValue, record)}
            type={record.type}
            updateFilter={this.zipSelect}
            hintText={record.hintText}
            filterValues={this.state.zipSelectValue}
            currentLanguage={this.props.currentLanguage}
            searchable
            tetherToWindow={false}
            searchBoxOpen='searchBoxOpen'
            SelectPlaceholderPopupColor={'White'}
            maxHeight={250}
            zipSearch={'zipSearch'}
            disabled={this.state.licensedStatesValue.length > 0 ? false : true}
          />
        </div>
      );
    });
    debug('views', _.compact(views));
    return _.compact(views);
  }

  searchLeads = () => {
    const { strings } = this.props;
    if (this.state.openSearch === true) {
      return (
        <Modal
          isOpen={this.state.openSearch}
          className="modalClass"
          overlayClassName="overlayClass"
        >
          <div className={styles.popupcontainer}>
            <div className={styles.popupBig}>
              <div className={styles.popupHeaderBig}>
                <div className={styles.popupHeaderDiv}>
                  <span className={styles.popupHeaderBigLabel}>
                    {strings.openLeadsSearch}
                  </span>
                </div>
              </div>
              {this.renderPopupForSearch()}
            </div>
          </div>
        </Modal>
      );
    }
    return '';
  }

  cancel() {
    this.setState({
      openSearch: false,
      isStateSelected: false,
      licensedStatesValue: [],
      citySelectValue: [],
      zipSelectValue: []
    });
  }

  popupAction = () => {
    if (this.props.popupVisible !== '') {
      this.props.hidePopup();
    } else {
      this.props.showPopup();
    }
  }
  closePopup = () => {
    this.props.hidePopup();
    this.props.fetchData().then(() => {
      this.props.applyFilter();
    }, errorResponse => debug(errorResponse));
  }
  openAddLeads = () => {
    const { strings } = this.props;
    if (this.props.popupVisible !== '') {
      return (
        <Popup
          textLabel={strings.newPersonalLead}
          closePopup={this.closePopup}
          popupType={4}
          buttonCarouselType={this.props.popupVisible}
        />
      );
    }
    return '';
  }

  renderPopupForSearch() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.mainFieldContainer}>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolder}>
              <div className={styles.inputTextDiv} >
                <div>{this.searchFilterDropdowns()}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onClick={() => this.searchButton()}
            >{strings.search}</button>
            <button
              className={styles.cancelSpan}
              onClick={() => this.cancel()}
            >{strings.cancel}</button>
            <Dialog
              actions={this.action(strings)}
              active={this.state.active}
              onEscKeyDown={this.handleToggle}
              onOverlayClick={this.handleToggle}
              className={styles.alertDialog}
              theme={styles}
            >
              <p>{this.state.errorMessage}</p>
            </Dialog>
          </div>
        </div>
      </div>
    );
  }
  render() {
    let columnValue = [];
    let filterValue = [];
    columnValue = this.getColumndata();
    filterValue = this.getFilterData();
    return (
      <div className={styles.flexDash}>
        {
          (this.state.isLoading || this.props.isLoadingData) &&
           <div className={styles.showIndicator}>
              <ProgressBar type="circular" mode="indeterminate" multicolor />
         </div>
        }
        <FixedTabs
          columnData={columnValue}
          activeIndex={this.props.activeIndex}
          updateActiveIndex={this.props.updateActiveIndex}
          updateFilterExpanded={this.props.updateFilterExpanded}
          filterExpanded={this.props.filterExpanded}
          filterData={filterValue}
          updateFilter={this.props.updateFilter}
          filterValues={this.props.filterValues}
          applyFilter={this.props.applyFilter}
          tabOneSearchedLeads={this.props.tabOneSearchedLeads}
          tabOneList={this.props.tabOneList}
          tabTwoList={this.props.tabTwoList}
          tabActiveLeadsList={this.props.tabActiveLeadsList}
          leadsData={this.props.leadsData}
          clearFilter={this.props.clearFilter}
          currentLanguage={this.props.currentLanguage}
          applySearchName={this.props.applySearchName}
          tabOneSearchList={this.props.tabOneSearchList}
          tabTwoSearchList={this.props.tabTwoSearchList}
          tabActiveSearchList={this.props.tabActiveSearchList}
          priAndSecRecordMapping={this.props.priAndSecRecordMapping}
          searchValueNameTabOne={this.props.searchValueNameTabOne}
          searchValueNamePriorityTab={this.props.searchValueNamePriorityTab}
          searchStreetAddressTabOne={this.props.searchStreetAddressTabOne}
          searchStreetAddressPriorityTab={this.props.searchStreetAddressPriorityTab}
          searchValueNameTabTwo={this.props.searchValueNameTabTwo}
          searchStreetAddressTabTwo={this.props.searchStreetAddressTabTwo}
          updateNameSearchParameter={this.props.updateNameSearchParameter}
          updateStreetSearchParameter={this.props.updateStreetSearchParameter}
          updatePhoneParameter={this.props.updatePhoneParameter}
          searchPhonePriorityTab={this.props.searchPhonePriorityTab}
          searchPhone={this.props.searchPhone}
          searchPhoneTabTwo={this.props.searchPhoneTabTwo}
          applySearchPhone={this.props.applySearchPhone}
          strings={this.props.strings}
        />
        {(__MANAGE__ &&
        this.props.activeIndex !== 1) &&
        <div className={!this.props.filterExpanded ? styles.float : styles.hidden}>
          <input
            type="image"
            src="static/add_leads.png"
            alt="Add"
            onClick={() => this.popupAction()}
          />
          {this.openAddLeads()}
        </div>}
        {(__MANAGE__ &&
        this.props.activeIndex === 1) &&
        <div className={!this.props.filterExpanded ? styles.search : styles.hidden}>
          <input
            type="image"
            src="static/search.png"
            alt="Add"
            onClick={() => this.searchPopupAction()}
          />
          {this.searchLeads()}
        </div>}
      </div>
    );
  }
}

/*
Following Actions are being mapped to props
  1) updateFilterExpanded
  2) updateFilter
  3) applyFilter
  4) clearFilter
*/

const mapStateToProps = state => ({
  tabOneList: state.manage.tabOneLeadsData,
  tabTwoList: state.manage.tabTwoLeadsData,
  tabActiveLeadsList: state.manage.tabActiveLeadsData,
  tabOneSearchList: state.manage.tabOneSearchData,
  tabTwoSearchList: state.manage.tabTwoSearchData,
  tabActiveSearchList: state.manage.tabActiveSearchData,
  tabOneSearchedLeads: state.manage.tabOneSearchedLeads,
  leadsData: state.manage.leadsManageData,
  error: state.manage.leadsManageError,
  activeIndex: state.manage.activeIndex,
  filterExpanded: state.manage.filterExpanded,
  popupVisible: state.manage.popupVisible,
  showPopup: state.manage.showPopup,
  hidePopup: state.manage.hidePopup,
  filterValues: state.manage.filter,
  priAndSecRecordMapping: state.manage.primaryAndSecondaryRecordMapping,
  searchValueNamePriorityTab: state.manage.searchValueNamePriorityTab,
  searchStreetAddressPriorityTab: state.manage.searchStreetAddressPriorityTab,
  searchPhonePriorityTab: state.manage.searchPhonePriorityTab,
  searchValueNameTabOne: state.manage.searchValueNameTabOne,
  searchStreetAddressTabOne: state.manage.searchStreetAddressTabOne,
  searchValueNameTabTwo: state.manage.searchValueNameTabTwo,
  searchPhone: state.manage.searchPhone,
  searchPhoneTabTwo: state.manage.searchPhoneTabTwo,
  searchStreetAddressTabTwo: state.manage.searchStreetAddressTabTwo,
  currentLanguage: state.manage.currentLanguage,
  licensedStates: state.manage.licensedStates,
  isLoading: state.manage.isLoading,
  isLoadingData: state.manage.isLoadingData
});
const ManageString = translate('Manage')(Manage);
export default connect(mapStateToProps, actions)(ManageString);



// WEBPACK FOOTER //
// ./src/containers/Manage/Manage.js